import { useState } from 'react';
import forEach from 'lodash/forEach';
import { ASSESSMENT_BUTTONS } from 'legacy/src/constants/assessmentPreviewButtons';

export default function ({
  pathname = '',
  query = {},
  isPreApSubject,
  questionBankTabs = false,
}) {
  const checkIfBQ = (item) => item.libraryType === 'QB';
  const [previewItemCurrentTabIndex, setPreviewItemCurrentTabIndex] =
    useState(0);

  let buttons = {};
  forEach(ASSESSMENT_BUTTONS, (button) => {
    buttons[button] = button;
  });

  const buttonsAvailability = {
    ppcMCQ: [buttons.scoringGuide, buttons.assign, buttons.viewQuizSummary],
    ppcFRQ: [
      buttons.printPreview,
      buttons.scoringGuide,
      buttons.assign,
      buttons.viewQuizSummary,
    ],
    preAp: [buttons.assign],
    qbPE: [
      buttons.printPreview,
      buttons.scoringGuide,
      buttons.assign,
      buttons.copy,
      buttons.viewQuizSummary,
      buttons.scoringWorksheet,
    ],
    qbOSP: [
      buttons.printPreview,
      buttons.scoringGuide,
      buttons.assign,
      buttons.viewQuizSummary,
    ],
    editable: [
      buttons.reorder,
      buttons.remove,
      buttons.printPreview,
      buttons.scoringGuide,
      buttons.assign,
      buttons.copy,
      buttons.edit,
      buttons.addQuestions,
      buttons.copyQuestion,
      buttons.viewQuizSummary,
    ],
  };

  const getVisibleButtons = (item) => {
    // we do back and forth with PE, so assuming PE on QB is everything what is NOt owned by teacher.
    // was that a Practice Exam is basically
    //
    // In QB
    // Not teacher-created
    const isSortOfPE = checkIfBQ(item) && !item.isOwner;

    if (item.isOwner) {
      return buttonsAvailability.editable;
    }

    if (isPreApSubject) {
      return buttonsAvailability.preAp;
    }

    if (isSortOfPE || item.isPracticeExam) {
      return buttonsAvailability.qbPE;
    }

    if (item.isCbPracticeQuiz) {
      return buttonsAvailability.qbOSP;
    }

    // PPC
    if (!checkIfBQ(item)) {
      // safely assume PPC FRQ has FRQ in title
      if (item.title && item.title.includes('FRQ')) {
        return buttonsAvailability.ppcFRQ;
      }
      return buttonsAvailability.ppcMCQ;
    }

    return [];
  };

  const isCreatePreview = pathname.includes('create/preview/quiz');
  const isQuestionsPreview = pathname.includes('questions/preview/quiz');
  const isPreviewPath = questionBankTabs
    ? isCreatePreview || isQuestionsPreview
    : isCreatePreview;
  const isPreviewQuiz = pathname ? isPreviewPath : Boolean(query.quizId);

  return {
    isPreviewQuiz,
    query,
    quizId: query.quizId,
    returnPath: query.returnPath && decodeURIComponent(query.returnPath),
    buttons,
    buttonsAvailability,
    getVisibleButtons,
    checkIfBQ,
    previewItemCurrentTabIndex,
    setPreviewItemCurrentTabIndex,
  };
}
